import { useTranslation } from 'react-i18next';

import { AsideHeader } from '@/components/ui';

/**
 * The budget rail's sticky header — the panel's identity, shared by
 * `ProjectBudgetAside` (a project with contracts) and `ProjectBudgetAsideEmpty`
 * (one without).
 *
 * Now a thin naming over `ui/AsideHeader`, which is the same header the Team
 * and Billing rails wear. This file stays because the title is the
 * financials-specific half, and its two callers should not have to know them.
 */

export type BudgetAsideHeaderProps = {
  projectName: string;
  /** The BR-6 project code, appended after a middot when the project has one. */
  projectCode?: string;
  /** Who the project is for. Lives here now, not in the page header. */
  customerName?: string;
};

export const BudgetAsideHeader = ({
  projectName,
  projectCode,
  customerName,
}: BudgetAsideHeaderProps) => {
  const { t } = useTranslation('pmCommon');
  return (
    <AsideHeader
      title={t('term.ProjectBudget')}
      meta={[projectName, projectCode, customerName]}
      automationId="budget-aside-header"
    />
  );
};
